module.exports = __webpack_public_path__ + "static/media/edit.0cc3357a.svg";